var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',_vm._g({attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"20","height":"20","fill":"none"}},_vm.$listeners),[_c('path',{attrs:{"fill":"currentColor","fill-rule":"evenodd","d":"M9.47 13.534 3.998 8.06 5.058 7 10 11.943 14.942 7l1.06 1.06-5.471 5.474a.75.75 0 0 1-1.061 0","clip-rule":"evenodd"}})])
}
var staticRenderFns = []

export default { render: render }